import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const mock = [
  {
    id: '00000000-0000-0000-0000-000000000001',
    name: 'Mock data 1',
  },
  {
    id: '00000000-0000-0000-0000-000000000002',
    name: 'Mock data 2',
  },
];

const index = new AxiosMockAdapter(instance);

index
  .onGet(/\/api\/metering-points\/mock-data(?:\?.*)?$/)
  .reply(200, mock)
  .onAny()
  .passThrough();
